module.exports = __webpack_public_path__ + "img/annotatedWeaponCard.44c4ccd9.jpg";